export const config = {
  apiUrl: process.env.REACT_APP_API_URL || "https://api-admin-dev.note.fun",
  noteFunUrl: process.env.REACT_APP_NOTE_FUN_URL || "https://note.fun",
};